import mixin from '../mixins/Mixin.js';
import mixinEditors from '../mixins/GrapesMixinEditors';
import loadComponents from '../plugins/image/components';
import { mapActions, mapGetters } from 'vuex';

export default {
  mixins: [mixin, mixinEditors],
  methods: {
    loadCanvasClear(commands) {
      var self = this;
      commands.add('canvas-clear', function() {
        self.$swal
          .fire({
            title: 'Êtes-vous sûr de réinitialiser le diapositive?',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#F44336',
            cancelButtonColor: '#2196F3',
            confirmButtonText: self.$t('modal.delete.btn_confirm'),
            cancelButtonText: self.$t('modal.delete.btn_cancel'),
            customClass: 'swal-delete',
          })
          .then(result => {
            if (result.value) {
              self.editor.DomComponents.clear();
              self.editor.select(self.editor.DomComponents.getWrapper());
              setTimeout(function() {
                localStorage.clear();
              }, 0);
              self.$swal.fire({
                title: 'Supprimé!',
                type: 'success',
                showConfirmButton: false,
                timer: 2000,
              });
              var iconSave = document.querySelector('.icon-save');
              if (iconSave) {
                iconSave.classList.add('icon-selected');
              }
            }
          });
      });
    },
    loadShowListPages(commands) {
      commands.add('list-page-show', function(e) {
        var panels_list_pages = document.querySelector('#panel__left');
        if (panels_list_pages.classList.contains('show_panel')) {
          panels_list_pages.classList.remove('show_panel');
        } else {
          panels_list_pages.classList.add('show_panel');
        }
      });
    },

    dragCreditBlock(el, cssComposer, editor, left, top, iframe, model) {
      let self = this;

      let heightCredit = el.getBoundingClientRect().height;
      let style = {
        position: 'fixed',
        left: (left / iframe.offsetWidth) * 100 + '%',
        bottom:
          100 -
          (top / iframe.offsetHeight) * 100 -
          (heightCredit / iframe.offsetHeight) * 100 +
          '%',
        right: '',
      };
      el.style.position = style.position;
      el.style.left = style.left;
      el.style.bottom = style.bottom;
      let id = model.getAttributes().id;
      const newId = 'i' + generateClass().substr(1);
      if (!id) {
        let attributes = editor.getSelected().getAttributes();
        attributes = attributes ? attributes : {};
        attributes.id = newId;
        editor.getSelected().setAttributes(attributes);
        style.oldLeft = style.left;
        cssComposer.setIdRule('classe', style);
        self.updateAlignement();
      } else {
        let oldStyle =
          cssComposer.getIdRule(id) && cssComposer.getIdRule(id).attributes
            ? cssComposer.getIdRule(id).attributes.style
            : {};

        oldStyle = Object.assign(oldStyle, style, { oldLeft: style.left });
        let attributes = editor.getSelected().getAttributes();
        attributes = attributes ? attributes : {};
        attributes.id = newId;
        editor.getSelected().setAttributes(attributes);
        cssComposer.setIdRule(newId, oldStyle);
        self.updateAlignement();
      }
    },

    dragElements(commands) {
      let self = this;
      commands.add('emp-move', {
        run(editor, sender, opts) {
          let iframe = document.querySelectorAll('.gjs-frame')[0];
          let cssComposer = editor.CssComposer;
          let style = {};
          var iconSave = document.querySelector('.icon-save');
          const rteToolbar = document.querySelector('.gjs-rte-toolbar');
          if (iconSave) {
            iconSave.classList.add('icon-selected');
          }
          function viewMove(e) {
            if (!dragEnabled) {
              editor.select(editor.DomComponents.getWrapper());
              iframe.contentWindow.removeEventListener('mousemove', viewMove, true);
              return;
            }
            const toolbar = document.querySelector('.gjs-toolbar');
            const resizer = document.querySelector('.gjs-resizer-c');
            const badge = document.querySelector('.gjs-badge');

            rteToolbar.style.display = 'none';
            toolbar.style.display = 'none';
            badge.style.display = 'none';
            if (resizer) {
              resizer.style.display = 'none';
            }

            let model = editor.getSelected();
            let el = model.view.el;
            const { width } = el.getBoundingClientRect();
            const left = Math.max(e.clientX - width + Math.min(width, 130), 0);
            const top = Math.max(e.clientY - 10, 0);

            const style = {
              position: 'fixed',
              left: (left / iframe.offsetWidth) * 100 + '% ',
              top: (top / iframe.offsetHeight) * 100 + '%'
            };

            //------------------------------------------------------------------
            if (editor.getSelected().get('type') === 'dateHeure') {
              let classes = model.getAttributes().class;
              if (classes) {
                classes = classes.split(' ');
                if (classes && classes[0]) {
                  let oldStyle =
                    cssComposer.getClassRule(classes[0]) &&
                    cssComposer.getClassRule(classes[0]).attributes
                      ? cssComposer.getClassRule(classes[0]).attributes.style
                      : {};
                  let newStyle = Object.assign({}, oldStyle, style);
                  cssComposer.setClassRule(classes[0], newStyle);
                }
              }
            }
            //--------------------------------------------------------------------
            else {
              el.style.position = style.position;
              el.style.left = style.left;
              el.style.top = style.top;

              let id = model.getAttributes().id;
              if (editor.getSelected().get('type') !== 'image') {
                const newId = 'i' + generateClass().substr(1);
                if (!id) {
                  editor.getSelected().setAttributes({ id: newId });
                  cssComposer.setIdRule('classe', style);
                } else {
                  let oldStyle =
                    cssComposer.getIdRule(id) && cssComposer.getIdRule(id).attributes
                      ? cssComposer.getIdRule(id).attributes.style
                      : {};

                  oldStyle = Object.assign(oldStyle, style);
                  editor.getSelected().setAttributes({ id: newId });
                  cssComposer.setIdRule(newId, oldStyle);
                }
              } else {
                let classes = model.getAttributes().class;
                if (classes) {
                  classes = classes.split(' ');
                  if (classes && classes[0]) {
                    let oldStyle =
                      cssComposer.getClassRule(classes[0]) &&
                      cssComposer.getClassRule(classes[0]).attributes
                        ? cssComposer.getClassRule(classes[0]).attributes.style
                        : {};
                    oldStyle = Object.assign(oldStyle, style);
                    cssComposer.setClassRule(classes[0], oldStyle);
                  }
                } else {
                  let oldStyle =
                    cssComposer.getIdRule(id) && cssComposer.getIdRule(id).attributes
                      ? cssComposer.getIdRule(id).attributes.style
                      : {};
                  oldStyle = Object.assign(oldStyle, style);
                  model.addClass('classe' + id);
                  cssComposer.setClassRule('classe' + id, oldStyle);
                }
              }
              if (model.attributes.type === 'social-icons-twitter') {
                model.view.updateScript();
                localStorage.setItem('gjs-js', editor.getJs());
              }
            } //--- end else
          }

          function mouseUp(e) {
            const model = editor.getSelected();
            if (editor && model) {
              if (model.get('type') === 'image') {
                let classes = model.getAttributes().class;
                if (classes) {
                  classes = classes.split(' ');
                  if (classes && classes[0]) {
                    const oldStyle =
                      cssComposer.getClassRule(classes[0]) &&
                      cssComposer.getClassRule(classes[0]).attributes
                        ? cssComposer.getClassRule(classes[0]).attributes.style
                        : {};
                    if (!(oldStyle.position && oldStyle.position === 'fixed')) {
                      style = {};
                    }
                    const newStyle = Object.assign({}, oldStyle, style);
                    const newClass = self.generateClass();
                    grapesjsEMP.editors[0].getSelected().removeClass(classes[0]);
                    grapesjsEMP.editors[0].getSelected().addClass(newClass);
                    cssComposer.setClassRule(newClass, newStyle);
                  }
                }
              } else if (model.get('type') === 'social-icons-twitter') {
                let classes = model.getAttributes().class;
                let id = model.getAttributes().id;
                if (classes) {
                  classes = classes.split(' ');
                  if (classes[0] && id) {
                    const oldStyle =
                      cssComposer.getClassRule(classes[0]) &&
                      cssComposer.getClassRule(classes[0]).attributes
                        ? cssComposer.getClassRule(classes[0]).attributes.style
                        : {};
                    const newStyle =
                      cssComposer.getIdRule(id) && cssComposer.getIdRule(id).attributes
                        ? cssComposer.getIdRule(id).attributes.style
                        : {};
                    const style = Object.assign({}, oldStyle, newStyle);
                    cssComposer.setClassRule(classes[0], style);
                  }
                }
              }
              if (model.get('type') === 'countdown' || model.get('type') === 'clocks') {
                model.view.updateScript();
                localStorage.setItem('gjs-js', editor.getJs());
              }
            }
            var iframe = document.querySelectorAll('.gjs-frame')[0];
            iframe.contentWindow.removeEventListener('mousemove', viewMove, true);
            iframe.contentWindow.removeEventListener('mouseup', mouseUp, true);

            const el = model.view.el;
            const margin = 15;
            const toolbar = document.querySelector('.gjs-toolbar');
            const resizer = document.querySelector('.gjs-resizer-c');
            const badge = document.querySelector('.gjs-badge');

            const { top, left, width, height } = el.getBoundingClientRect();
            const iframeLeft = iframe.getBoundingClientRect().left;
            const iframeTop = iframe.getBoundingClientRect().top;
            const iframeWidth = iframe.getBoundingClientRect().width;
            const element = e.target;
            const viewportTop = window.pageYOffset || document.documentElement.scrollTop;
            const elementTop = element.offsetTop;
            const topPosition = elementTop - viewportTop;
            toolbar.style.display = 'block';

            const toolbarWidth = toolbar.getBoundingClientRect().width;
            const toolbarHeight = toolbar.getBoundingClientRect().height;

            if (resizer && model.attributes.resizable) {
              resizer.style.display = 'block';
              //resizer.style.top =  margin + iframeTop/2 + top + 'px';
              resizer.style.top = margin + top + 'px';
              resizer.style.left = iframeLeft + left + 'px';

              if (model.attributes.type === 'text') {
                resizer.style.width = width + 'px';
                resizer.style.height = height + 'px';
              }
            }
            toolbar.style.top = Math.max(margin + top - toolbarHeight, 15) + 'px';
            toolbar.style.left =
              iframeLeft + Math.min(left + width, iframeWidth) - toolbarWidth + 'px';

            badge.style.top = Math.max(margin + top - 18, 15) + 'px';
            badge.style.left = iframeLeft + left + 'px';
            badge.style.display = 'block';
          }

          iframe.contentWindow.removeEventListener('mouseup', mouseUp, true);
          iframe.contentWindow.removeEventListener('mousemove', viewMove, true);

          if (event.type === 'mousedown') {
            iframe.contentWindow.addEventListener('mousemove', viewMove, true);
            iframe.contentWindow.addEventListener('mouseup', mouseUp, true);
          }
        },
        stop(editor, sender, opts) {
          let event = opts && opts.event;
          const rteToolbar = document.querySelector('.gjs-rte-toolbar');
          rteToolbar.style.display = 'block';
        }
      });
    },

    getCurrentRotationFixed(element) {
      var st = window.getComputedStyle(element, null);
      var tr =
        st.getPropertyValue('-webkit-transform') ||
        st.getPropertyValue('-moz-transform') ||
        st.getPropertyValue('-ms-transform') ||
        st.getPropertyValue('-o-transform') ||
        st.getPropertyValue('transform') ||
        'fail...';

      if (tr !== 'none') {
        var values = tr.split('(')[1];
        values = values.split(')')[0];
        values = values.split(',');
        var a = values[0];
        var b = values[1];
        var c = values[2];
        var d = values[3];

        var scale = Math.sqrt(a * a + b * b);

        // First option, don't check for negative result
        // Second, check for the negative result
        /**/
        var radians = Math.atan2(b, a);
        var angle;
        angle = Math.round(radians * (180 / Math.PI));
      } else {
        angle = 0;
      }

      // works!
      return angle;
    },
    getRectOfElement(element) {
      const iframe = document.querySelector('iframe.gjs-frame');
      const transform = element.style.transform;
      element.style.transform = 'rotate(0)';
      const clientRect = element.getBoundingClientRect();
      const iframeRect = iframe.getBoundingClientRect();
      const style = window.getComputedStyle(element);
      let clientCenter = {
        x: iframeRect.left + clientRect.left + parseFloat(style.width) / 2,
        y: iframeRect.top + clientRect.top - 55,
        width: parseFloat(style.width),
        height: parseFloat(style.height),
      };
      element.style.transform = transform;
      return clientCenter;
    },
    changeModalBackgImage(editor, comp, id) {
      var self = this;
      editor.on('run:open-assets', () => {
        editor.Modal.close();
        self.openModal(id, comp);
      });
    },
    openModal(id, comp) {
      let self = this;
      if (document.getElementById(id + '-iframe')) {
        document.getElementById(id + '-iframe').style.display = 'block';
        document.getElementById('CanvOverlay').style.display = 'block';
        self.translatePluginsTitle(comp, 'image');
        self.setCloseImageModal(comp, id);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/GrapesMixinCommands.js